import { useBadgeNotifications } from '@/hooks/useBadgeNotifications';

const BadgeNotificationListener = () => {
  useBadgeNotifications();
  return null;
};

export default BadgeNotificationListener;
